import script from "./PopulationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PopulationPanel.vue?vue&type=script&setup=true&lang=js"

import "./PopulationPanel.vue?vue&type=style&index=0&id=5be4fc9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be4fc9c"]])

export default __exports__